export enum ControlLevel {
  Off = 0,
  Campaign = 1,
  Profile = 2,
  Audience = 2
}
